import { useContext, useState } from 'react';
import { getGelTokens } from "@tal-gel/theming";
import {
    GelSpinner,
    GelButton
} from "@tal-gel/components";
import Card from '../../../common/components/card';
import NotificationList from './notification-list';
import { AdobeClickType, NotificationType } from '../../../constants/constants';
import { MARK_HISTORICAL_PAYMENTS_AS_READ } from '../../../graphql/queries/graphql-mutations';
import { AdobeAnalytics } from '../../../common/analytics/adobe-analytics';
import { useCookies } from 'react-cookie';
import { UserContext } from '../../../common/usercontext/user.context';
import { MemberNotification, Requirements } from '../../../common/models/memberclaims';
import { useGetClaimDetailsContent } from '../../../common/api/graphQLDataFetch';
import MmcGraphQL from '../../../common/api/mmc-graphql';

interface NotificationCardProps {
    requirements: Requirements[];
    isNotificationDataLoaded: Boolean;
    notifications: MemberNotification[];
}

const NotificationCard = ({ requirements, isNotificationDataLoaded }: NotificationCardProps) => {
    const [{ tpid }] = useCookies(['tpid']);
    const { setUserContext } = useContext(UserContext);
    const { data } = useGetClaimDetailsContent();
    const [notificationUpdating, setnotificationUpdating] = useState(false);

    const { global: { sizeBaseX20 } } = getGelTokens();

    const visibleRequirements = requirements.filter(({ type, completedDate }) =>
        [NotificationType.ProceesedPayment, NotificationType.Activity, NotificationType.FuturePayment]
            .includes(type) || !completedDate);
    
    const visibleNotifications = requirements
        .filter(({ type }) => type === NotificationType.ProceesedPayment)

    const clearNotifications = () => {
        AdobeAnalytics.PushClickEvent(tpid, "Close", AdobeClickType.Link)

        let notificationIdsToClear = visibleNotifications.map(({ id }) => id);

        if (notificationIdsToClear.length === 0)
            return;

        setnotificationUpdating(true);

        MmcGraphQL<{ paymentIds: number[] }>(MARK_HISTORICAL_PAYMENTS_AS_READ, { paymentIds: notificationIdsToClear })
            .then(({ paymentIds }) => {
                const cleared = new Set(paymentIds ?? []);

                setUserContext((prev: UserContext) => {
                    if (!prev) return prev;

                    const claims = (prev.claims ?? []).map(c => ({
                        ...c,
                        requirements: (c.requirements ?? []).filter(req => req.id !== undefined && !cleared.has(req.id)),
                    }));

                    return { ...prev, claims };
                });

            setnotificationUpdating(false);
        })
    }

    return (<Card
        title={data?.notificationsCardHeader!}
        showFooter={false}
    >
        {(!isNotificationDataLoaded) &&
            <div style={{ height: sizeBaseX20 }}>
                <GelSpinner medium overlay />
            </div>}

        {notificationUpdating && <GelSpinner medium overlay />}

        {(isNotificationDataLoaded) && (
            <>
                {visibleNotifications.length > 0 && 
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ paddingRight: `10px`, paddingTop: '5px',  marginBottom: '-35px'}}>
                        <GelButton
                            tertiary
                            small
                            onClick={clearNotifications}
                        >
                            Mark all notifications as read
                        </GelButton>
                    </div>
                </div>
                }
                <NotificationList requirements={visibleRequirements} />
            </>
        )}
    </Card>);
}

export default NotificationCard;